import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DebugLoggerService } from '../services/debug-logger.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  private _debugLogger = inject(DebugLoggerService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    return next.handle(req).pipe(
      tap(
        response => {
          if (response instanceof HttpResponse) {
            const duration = Date.now() - startTime;
            const body = ['POST', 'PUT', 'PATCH'].includes(req.method) ? req.body : undefined;
            this._debugLogger.logHttp(req.method, req.urlWithParams, body, response.body, duration);
          }
        },
        error => {
          const duration = Date.now() - startTime;
          this._debugLogger.logHttpError(req.method, req.urlWithParams, error, duration);
        }
      ),
    );
  }
}
